if (!customElements.get("product-info")) {
  const DELIVERY_INFO_SELECTOR = '.js-delivery-info';

  const updateDeliveryInfo = (sourceDocument) => {
    const sourceDeliveryInfo = sourceDocument.querySelector(DELIVERY_INFO_SELECTOR);
    const targetDeliveryInfo = document.querySelector(DELIVERY_INFO_SELECTOR);

    if (sourceDeliveryInfo && targetDeliveryInfo) {
      targetDeliveryInfo.innerHTML = sourceDeliveryInfo.innerHTML;
    }
  };

  const updatePickUpInfoAJAX = (variant) => {
    if (!variant?.id) {
      console.error("Invalid variant provided");
      return;
    }

    fetch(
      window.Shopify.routes.root +
      `variants/${variant.id}/?section_id=pickup-availability-custom`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const container = document.querySelector(
          ".js-click-and-collect-wrapper"
        );
        if (!container) {
          throw new Error("Container element not found");
        }
        container.innerHTML = "";

        const pickupAvailabilityHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");

        if (!pickupAvailabilityHTML) {
          throw new Error(
            "Pickup availability section not found in the response"
          );
        }

        container.innerHTML = pickupAvailabilityHTML.innerHTML;

        pickUpFunctionality();
      })
      .catch((e) => {
        console.error("Error updating pickup info:", e);
      });
  };

  const pickUpFunctionality = () => {
    const clickAndCollectDialog = document.querySelector(
      ".js-click-and-collect__dialog"
    );
    const dialogOpenButton = document.querySelector(
      ".js-click-and-collect__button"
    );
    const dialogCloseButton = document.querySelector(
      ".js-click-and-collect__close-button"
    );
    if (!clickAndCollectDialog) {
      return;
    }
    dialogOpenButton.addEventListener("click", function pickUpOpener(e) {
      clickAndCollectDialog.showModal();
    });

    dialogCloseButton.addEventListener("click", (e) => {
      clickAndCollectDialog.close();
    });

    clickAndCollectDialog.addEventListener("click", (e) => {
      const dialogDimensions = clickAndCollectDialog.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        clickAndCollectDialog.close();
      }
    });
  };

  const updatePickUpInfo = (variant) => {
    updatePickUpInfoAJAX(variant);
  };

  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector(".quantity__input");
        this.originalSizeChartElements = []; // Store original size chart elements
        this.sizeChartElementsCaptured = false; // Track if we've captured them yet
        this.closeWarning(true);
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        // Delay capture to allow app to populate size chart elements
        setTimeout(() => {
          this.captureOriginalSizeChartElements();
        }, 1000);

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      setVariantAvailability() {
        fetch(
          window.Shopify.routes.root +
          "variants/[variant-id]/?section_id=pickup-availability"
        )
          .then((response) => response.text())
          .then((text) => {
            const container = document.querySelector(
              "[data-store-availability-container]"
            );
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");

            container.appendChild(pickupAvailabilityHTML);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      captureOriginalSizeChartElements() {
        // Don't capture if already done
        if (this.sizeChartElementsCaptured) {
          console.log('⏭️ Size chart elements already captured, skipping');
          return;
        }

        // Capture original size chart elements with their parent info
        const sizeChartElements = this.variantSelectors?.querySelectorAll('.product-variant-picker__size-chart');
        console.log('🎯 Capturing original size chart elements:', sizeChartElements);

        if (sizeChartElements && sizeChartElements.length > 0) {
          // Check if elements have content (app has populated them)
          const elementsWithContent = Array.from(sizeChartElements).filter(element => {
            const hasContent = element.textContent.trim() !== '' || element.innerHTML.trim() !== '';
            console.log('📝 Element content check:', element, 'hasContent:', hasContent);
            return hasContent;
          });

          if (elementsWithContent.length === 0) {
            console.log('⚠️ Size chart elements found but no content yet, waiting...');
            return; // Don't capture empty elements
          }

          this.originalSizeChartElements = elementsWithContent.map(element => {
            const parentLabel = element.closest('.form__label');
            const labelText = parentLabel?.textContent?.trim() || '';

            console.log('💾 Storing original element with label:', labelText, 'content:', element.textContent);


            return {
              element: element, // Original element with event listeners
              labelText: labelText,
              parentLabel: parentLabel
            };
          });

          this.sizeChartElementsCaptured = true;
          console.log('✅ Stored original size chart elements:', this.originalSizeChartElements.length);
        } else {
          console.log('❌ No size chart elements found to capture');
        }
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          publish(PUB_SUB_EVENTS.sectionRefreshed, {
            data: {
              sectionId: this.sectionId,
              resource: {
                type: SECTION_REFRESH_RESOURCE_TYPE.product,
                id: newNode.dataset.productId,
              },
            },
          });
        });
      }
      getActiveVariantId() {
        const variantIdElement = document.querySelector(".product-variant-id");
        if (variantIdElement) return variantIdElement.value;
        return null;
      }

      updateGrundPreisValue(variant, priceElem) {
        if (!variant.unit_price || !priceElem) return;

        const formatToGermanCurrency = (cents) => {
          const euros = cents / 100;
          return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(euros);
        };

        const newUnitPriceElem = `
        <div class="price__unit">
          <span class="price-unit-price">
            <span data-unit-price>${formatToGermanCurrency(
          variant.unit_price
        )}</span>
            <span aria-hidden="true"> / </span>
            <span>${variant.unit_price_measurement.reference_unit}</span>
          </span>
          </div>`;

        priceElem.insertAdjacentHTML("beforeend", newUnitPriceElem);
      }

      getMatchedOptionValue(target, selectedOptionValues) {
        const totalSelector = document.querySelectorAll('.select.product-variant-picker-selector').length;
        
        // If there are multiple selectors, return the full array so each value can be matched to its select
        if (totalSelector > 1) {
          console.log('📋 Multiple selectors found, returning full array:', selectedOptionValues);
          return selectedOptionValues;
        }
        
        // For single selector, find the matching value
        // First, try to find the value that matches a dropdown (select with "bittewahlen" option)
        const allSelects = document.querySelectorAll('.product-variant-picker-selector select');
        
        for (const valueId of selectedOptionValues) {
          for (const select of allSelects) {
            // Check if this select has the "bittewahlen" option (meaning it's a dropdown)
            const hasBitteWahlen = select.querySelector('option[id="bittewahlen"]');
            if (hasBitteWahlen) {
              // Check if this value matches an option in this dropdown
              const matchingOption = select.querySelector(`option[data-option-value-id="${valueId}"]`);
              if (matchingOption) {
                console.log('✅ Found matching option value in dropdown:', valueId, 'for select:', select.id);
                return valueId;
              }
            }
          }
        }
        
        // If no dropdown match found, check the target's associated select
        let selectElement = null;
        
        if (target.tagName === 'SELECT') {
          selectElement = target;
        } else if (target.tagName === 'OPTION') {
          selectElement = target.closest('select');
        } else if (target.closest('select')) {
          selectElement = target.closest('select');
        } else if (target.closest('.product-variant-picker-selector')) {
          // If target is in a variant picker (like image picker/swatch), find the associated select
          const pickerContainer = target.closest('.product-variant-picker-selector');
          selectElement = pickerContainer.querySelector('select');
        }
        
        // If we found a select element, try to match values from the array
        if (selectElement) {
          // Check each value in selectedOptionValues array
          for (const valueId of selectedOptionValues) {
            // Find option with matching data-option-value-id
            const matchingOption = selectElement.querySelector(`option[data-option-value-id="${valueId}"]`);
            if (matchingOption) {
              console.log('✅ Found matching option value:', valueId, 'for select:', selectElement.id);
              return valueId;
            }
          }
          
          // If no match found but we have a select, check if target has data-option-value-id
          if (target.dataset?.optionValueId) {
            const targetValueId = target.dataset.optionValueId;
            if (selectedOptionValues.includes(targetValueId)) {
              console.log('✅ Found matching value from target data-option-value-id:', targetValueId);
              return targetValueId;
            }
          }
        }
        
        // Fallback to existing logic if no match found
        if (selectedOptionValues.length === 1) {
          return selectedOptionValues[0];
        } else {
          return selectedOptionValues[1];
        }
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        console.log('🔄 handleOptionValueChange called with target:', target.value, 'selectedOptionValues:', selectedOptionValues);
        const totalSelector = document.querySelectorAll('.select.product-variant-picker-selector').length;
        this.closeWarning(false); //Close low quantity warning if present after switching the variant/option
        if (!this.contains(event.target)) return;
        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          !this.isFeaturedProduct && shouldSwapProduct;

        // Get the matched option value based on DOM
        const matchedValue = this.getMatchedOptionValue(target, selectedOptionValues);

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl)
            : this.handleUpdateProductInfo(productUrl, matchedValue),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      get isFeaturedProduct() {
        return this.dataset.section.includes("featured_product");
      }

      handleSwapProduct(productUrl) {
        return (html) => {
          this.productModal?.remove();

          // Grab the selected variant from the new product info
          const variant = this.getSelectedVariant(
            html.querySelector(`product-info[data-section=${this.sectionId}]`)
          );
          this.updateURL(productUrl, variant?.id);

          // If we are in an embedded context (quick add, featured product, etc), only swap product info.
          // Otherwise, refresh the entire page content and sibling sections.
          if (this.dataset.updateUrl === "false") {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        this.pendingRequestUrl = requestUrl;
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        console.log('🔄 updateOptionValues called with html:', html);

        const variantSelects = html.querySelector("variant-selects");
        console.log('📦 Found variantSelects:', !!variantSelects);

        if (variantSelects) {
          // Try to capture size chart elements if not done yet (fallback)
          if (!this.sizeChartElementsCaptured) {
            console.log('🔄 Attempting fallback capture of size chart elements');
            this.captureOriginalSizeChartElements();
          }

          // Post-process callback to restore original size chart elements
          const restoreSizeChart = (newNode) => {
            console.log('🔧 restoreSizeChart callback executed with newNode:', newNode);
            console.log('📊 Using stored original elements:', this.originalSizeChartElements.length);

            // Find all labels that should have size charts (Größe or Schuhgröße)
            const allLabels = Array.from(newNode.querySelectorAll('.product-variant-picker__label-for-size'));
            console.log('🔍 Found all labels:', allLabels.length);

            allLabels.forEach(label => {
              const labelText = label.textContent.trim();
              console.log('🏷️ Checking label text:', labelText);

              // Check if this label should have a size chart
              const shouldHaveSizeChart = labelText.includes('Größe') || labelText.includes('Schuhgröße');
              console.log('📏 Should have size chart:', shouldHaveSizeChart);

              if (shouldHaveSizeChart) {
                // Find matching original element
                const matchingData = this.originalSizeChartElements.find(({ labelText: originalText }) => {
                  if (!originalText) return false;
                  return (originalText.includes('Größe') && labelText.includes('Größe')) ||
                    (originalText.includes('Schuhgröße') && labelText.includes('Schuhgröße'));
                });

                if (matchingData) {
                  console.log('➕ Appending stored original size chart element to label');
                  label.appendChild(matchingData.element); // Reuse original element with event listeners
                } else {
                  console.log('❌ No matching original size chart found');
                }
              } else if (shouldHaveSizeChart) {
                console.log('⚠️ Size chart already exists in this label');
              } else {
                console.log('⏭️ Label does not need size chart');
              }
            });

            const totalSelectors = this.variantSelectors
              ? this.variantSelectors.querySelectorAll('.select.product-variant-picker-selector')
              : this.querySelectorAll('.select.product-variant-picker-selector');

            // Normalize selectedValueId to always be an array
            const selectedValueIds = Array.isArray(window.selectedValueId) 
              ? window.selectedValueId 
              : [window.selectedValueId];

            // For each select, find and select the matching option
            document.querySelectorAll("select.select__select").forEach((select) => {
              let optionToSelect = null;

              // Try to find a matching option for this select
              for (const valueId of selectedValueIds) {
                if (valueId) {
                  optionToSelect = select.querySelector(`option[data-option-value-id="${valueId}"]`);
                  if (optionToSelect) {
                    console.log('✅ Found matching option for select:', select.id, 'with value:', valueId);
                    break;
                  }
                }
              }

              console.log('OptionSelector for', select.id, ':', optionToSelect);

              if (optionToSelect) {
                optionToSelect.selected = true;

                // // Trigger change event
                // const changeEvent = new Event("change", { bubbles: true });
                // select.dispatchEvent(changeEvent);
              } else {
                console.log('⚠️ No matching option found for select:', select.id, 'with values:', selectedValueIds);
              }
            });




          };

          console.log('🚀 Calling HTMLUpdateUtility.viewTransition with callbacks');
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
            [restoreSizeChart, ...this.postProcessHtmlCallbacks]
          );

        } else {
          console.log('❌ No variantSelects found in HTML');
        }
      }

      changePrice(newPrice, newCompareAtPrice, variant) {
        const formatPrice = (priceInCents) => {
          return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(priceInCents / 100);
        };

        const productInfo = document.querySelector("product-info");
        const compareAtPriceElem = productInfo.querySelector(
          ".js-product-price-block-compare-price"
        );
        const priceElem = productInfo.querySelector(
          ".js-product-price-block-price"
        );
        const percentageElem = productInfo.querySelector(
          ".js-product-price-block-percentage"
        );

        const newPercentage = Math.round(
          ((newCompareAtPrice - newPrice) / newCompareAtPrice) * 100
        );
        const showCompare = newPercentage >= 5;

        priceElem.textContent = formatPrice(newPrice);
        this.updateGrundPreisValue(variant, priceElem);

        if (
          compareAtPriceElem &&
          newCompareAtPrice &&
          newCompareAtPrice > newPrice &&
          showCompare
        ) {
          compareAtPriceElem.textContent = formatPrice(newCompareAtPrice);
          compareAtPriceElem.classList.remove("hidden");
          priceElem.classList.add("--discounted");
        } else {
          compareAtPriceElem.classList.add("hidden");
          priceElem.classList.remove("--discounted");
        }

        if (percentageElem && newPercentage >= 5) {
          percentageElem.textContent = "-" + newPercentage + " %";
          percentageElem.classList.remove("hidden");
        } else {
          percentageElem.classList.add("hidden");
        }
      }

      handleUpdateProductInfo(productUrl, selectedValueId) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          const mobileActivator = document.querySelector(
            ".js-swatch-input__too-much--mobile"
          );
          const desktopActivator = document.querySelector(
            ".js-swatch-input__too-much--desktop"
          );

          const variantsExtrudedDesktop = desktopActivator
            ? desktopActivator.classList.contains("clicked")
            : false;
          const variantsExtrudedMobile = mobileActivator
            ? mobileActivator.classList.contains("clicked")
            : false;
          window.selectedValueId = selectedValueId;
          console.log('Selected Value ID(s):', selectedValueId);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updatePdpOffer(html);

          if (!variant) {
            this.setUnavailable();
            updatePickUpInfo(variant);
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          this.changePrice(variant.price, variant.compare_at_price, variant);
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );
          updateDeliveryInfo(html, variant);
          updatePickUpInfo(variant);

          const skuHolder = document.querySelectorAll(
            ".js-product-description__sku-holder"
          );
          Array.from(skuHolder).forEach((span) => {
            span.innerText = variant.sku;
          });

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          const mobileActivatorNew = document.querySelector(
            ".js-swatch-input__too-much--mobile"
          );
          const desktopActivatorNew = document.querySelector(
            ".js-swatch-input__too-much--desktop"
          );

          if (desktopActivatorNew && variantsExtrudedDesktop) {
            desktopActivatorNew.classList.add("clicked");
          }

          if (mobileActivatorNew && variantsExtrudedMobile) {
            mobileActivatorNew.classList.add("clicked");
          }

          const sectionId = "product-description";
          const productDescriptionSection = document.querySelector(
            ".js-product-details"
          );
          const url = new URL(window.location.href);
          url.searchParams.set("sections", sectionId);
          fetch(url)
            .then((response) => response.text())
            .then((jsonString) => {
              const { "product-description": productDescription } =
                JSON.parse(jsonString);
              const parser = new DOMParser();
              const doc = parser.parseFromString(
                productDescription,
                "text/html"
              );
              const productDetailsHTML =
                doc.querySelector(".js-product-details")?.innerHTML || "";
              if (productDescriptionSection) {
                productDescriptionSection.innerHTML = productDetailsHTML;
              }
            })
            .catch((error) => console.error("Error fetching section:", error));

          document
            .querySelector(".js-product-variants-parent")
            .dispatchEvent(new Event("change", { bubbles: true }));
        };
      }
      

      updatePdpOffer(html) {
        const pdpOffer = html.querySelector(".product-price-content");
        const pdpOfferContent = document.querySelector('.product-price-content');
        if (!pdpOffer && !pdpOfferContent) return;
        const discountPercentage = parseInt(pdpOffer.querySelector('.product-price-banner').getAttribute('data-discount-percentage'));

        pdpOfferContent.innerHTML = pdpOffer.innerHTML;
        if (discountPercentage == 0) {
         document.querySelector('.product__info-wrapper .product-price-block ').classList.remove('offer-active');
        }
        else {
          document.querySelector('.product__info-wrapper .product-price-block ').classList.add('offer-active');
        }
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {

        let isBitteWahlen = false;
        const select = document.querySelector(".select__select");
        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption?.id === "bittewahlen") {
            isBitteWahlen = true;
          }
        }


        this.productForm?.toggleSubmitButton(
          true,
          isBitteWahlen
            ? window.variantStrings.addToCart
            : window.variantStrings.unavailable
        );


        const selectors = [
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");

        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        if (variantFeaturedMediaId) {
          // set featured media as active in the media gallery
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );

          // update media modal
          const modalContent = this.productModal?.querySelector(
            `.product-media-modal__content`
          );
          const newModalContent = html.querySelector(
            `product-modal .product-media-modal__content`
          );
          if (modalContent && newModalContent)
            modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      closeWarning(close) {
        const warnCloseButton = document.querySelector(".warn-close");
        const warnMsg = document.getElementById("warn-msg");
        if (close && warnCloseButton && warnMsg) {
          warnCloseButton.addEventListener("click", function (event) {
            event.preventDefault();
            warnMsg.style.display = "none";
          });
        } else {
          warnMsg.style.display = "none";
        }
      }
      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}


function hideQuickAddIfFormDisabled() {
  const formButton = document.querySelector('.product-form__submit');
  const hiddenButton = document.querySelector('.quick-add-hidden-button');

  if (formButton && hiddenButton) {
    if (formButton.disabled) {
      if (hiddenButton.style.display !== 'none') {
        hiddenButton.style.display = 'none';
      }
    } else {
      if (hiddenButton.style.display === 'none') {
        hiddenButton.style.display = '';
      }
    }
  }
}

function initHoverEffect() {
  const formButton = document.querySelector('.product-form__submit');
  const hiddenBitteWahlenOption = document.querySelector('.quick-add-hidden-button');

  if (formButton && hiddenBitteWahlenOption) {
    hiddenBitteWahlenOption.addEventListener('mouseenter', () => {
      formButton.classList.add('hovered');
    });

    hiddenBitteWahlenOption.addEventListener('mouseleave', () => {
      formButton.classList.remove('hovered');
    });
  }
}

function myInitCode() {
  const formButton = document.querySelectorAll('.product-form__submit')[0];
  const hiddenBitteWahlenOption = document.querySelector('.quick-add-hidden-button');

  if (!formButton || !hiddenBitteWahlenOption) return;


  const observer = new MutationObserver(() => {
    console.log('MutationObserver detected a change in formButton attributes');
    hideQuickAddIfFormDisabled();
  });
  observer.observe(formButton, { attributes: true, attributeFilter: ['disabled'] });


  hideQuickAddIfFormDisabled();


  hiddenBitteWahlenOption.addEventListener('click', (event) => {
    // Find the selector that contains the "Bitte wählen" option
    const allSelects = document.querySelectorAll('.product-variant-picker-selector select');
    let productSizeSelect = null;
    
    // Loop through all selects to find the one with the "bittewahlen" option
    for (let i = 0; i < allSelects.length; i++) {
      const select = allSelects[i];
      const bitteWahlenOption = select.querySelector('option[id="bittewahlen"]');
      if (bitteWahlenOption) {
        productSizeSelect = select;
        break;
      }
    }
    const klaviyoButton = document.querySelector('a.button.klaviyo-bis-trigger');
    const testSelector =  document.querySelectorAll('.ASM-3__size-selection-layout')[0];
    if (testSelector) {
      return;
    }

    if (productSizeSelect) {
      if (window.getComputedStyle(formButton).display !== 'none' && productSizeSelect.value !== "Bitte wählen") {
        formButton.submit();
        console.log('ClickedForm Button1')
      } else if (klaviyoButton && productSizeSelect.value !== "Bitte wählen") {
        if (window.getComputedStyle(klaviyoButton).display !== 'none') {
          klaviyoButton.click();
        }
      } else {
        event.preventDefault();
        openSelectDropdown(productSizeSelect);
      }
    }
  });
}


if (document.readyState !== 'loading') {
  console.log('document is already ready, just execute code here');
  myInitCode();
  initHoverEffect();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    console.log('document was not ready, place code here');
    myInitCode();
    initHoverEffect();
  });
}


function openSelectDropdown(selectElement) {

  if (selectElement && typeof selectElement.showPicker === 'function') {
    selectElement.showPicker();
  }

  else if (selectElement) {
    const event = new MouseEvent('mousedown', {
      view: window,
      bubbles: true,
      cancelable: true
    });

    selectElement.dispatchEvent(event);
    setTimeout(() => {
      selectElement.click();
    }, 10);
  }
}



if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    static get observedAttributes() {
      return ['data-end-date', 'end-date'];
    }

    constructor() {
      super();
      this._timerId = null;
    }

    connectedCallback() {
      this._start();
    }

    disconnectedCallback() {
      if (this._timerId) clearInterval(this._timerId);
    }

    attributeChangedCallback() {
      this._start();
    }

    _parseAsGermanTime(dateString) {
      const trimmed = dateString.trim();
      const hasTimezone = /[+-]\d{2}:?\d{2}$|Z$/i.test(trimmed);
      
      if (hasTimezone) {
        // Has timezone - parse normally
        return new Date(dateString);
      } else {
        // No timezone - interpret as German local time (Europe/Berlin)
        const match = trimmed.match(/(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}):(\d{2}))?/);
        if (!match) {
          return new Date(trimmed);
        }
        
        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1;
        const day = parseInt(match[3]);
        const hour = match[4] ? parseInt(match[4]) : 0;
        const minute = match[5] ? parseInt(match[5]) : 0;
        const second = match[6] ? parseInt(match[6]) : 0;
        
        // Target German time string
        const targetStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
        
        // Find UTC timestamp for this German time using iterative refinement
        let testUTC = new Date(Date.UTC(year, month, day, hour - 1, minute, second));
        
        for (let i = 0; i < 25; i++) {
          const testStr = testUTC.toLocaleString('sv-SE', { timeZone: 'Europe/Berlin' });
          if (testStr === targetStr) {
            return testUTC;
          }
          
          const [, testTime] = testStr.split(' ');
          const [testH, testM, testS] = testTime.split(':').map(Number);
          const diffSec = (hour * 3600 + minute * 60 + second) - (testH * 3600 + testM * 60 + testS);
          
          if (Math.abs(diffSec) < 1) break;
          testUTC = new Date(testUTC.getTime() + diffSec * 1000);
        }
        
        return testUTC;
      }
    }

    _start() {
      if (this._timerId) clearInterval(this._timerId);

      const endAttr =
        this.getAttribute('data-end-date') ||
        this.getAttribute('end-date') ||
        this.getAttribute('datetime');

      if (!endAttr) return;

      const endDate = this._parseAsGermanTime(endAttr);
      const endTime = endDate.getTime();
      if (isNaN(endTime)) return;

      const el = this;

      function update() {
        // Both endTime and nowUTC are UTC timestamps
        // endTime was parsed as German time and converted to UTC
        // nowUTC is current UTC time
        // The difference gives us the correct countdown
        const nowUTC = Date.now();
        const diffSec = Math.floor((endTime - nowUTC) / 1000);

        if (diffSec <= 0) {
          el.textContent = '00:00:00';
          clearInterval(el._timerId);
          el._timerId = null;
          return;
        }

        const hours = Math.floor(diffSec / 3600);
        const minutes = Math.floor((diffSec % 3600) / 60);
        const seconds = diffSec % 60;

        el.textContent =
          String(hours).padStart(2, '0') + ':' +
          String(minutes).padStart(2, '0') + ':' +
          String(seconds).padStart(2, '0');
      }

      update();
      this._timerId = setInterval(update, 1000);
    }
  }


    customElements.define('countdown-timer', CountdownTimer);
  }
